
import { StateCreator } from 'zustand';
import {
    WorkflowI,
    WorkflowActionI,
} from '../../../libs/interfaces';

export const createWorkflowFSlice: StateCreator<WorkflowI & WorkflowActionI, [], []> = ((set, get) => ({
    activeKey:["1"],
    setActiveKey: (activeKey) => set(() => ({ activeKey })),
    step: 'Formulario',
    setStep: (step) => set(() => ({ step })),
    resetSteps: () => set(() => ({
        step: 'Formulario',
    }))
}));
